// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import styled from '../utils/styled';
import {
  mediaBreakpointUpSM,
  mediaBreakpointUpMD,
  mediaBreakpointUpXL,
} from '../../constants/style-constants';

const MenuWrapper = styled.div(({
  right, open, topSpace, alternate, flexDirection,
}) => ({
  /* stylelint-disable selector-type-case, selector-type-no-unknown, string-quotes */
  display: open ? 'flex' : 'none',
  backgroundColor: alternate ? '#f6f6f6' : '#0f0f0f',
  flexDirection,
  overflow: 'auto',
  opacity: '0',
  left: right ? '60px' : '0',
  top: '60px',
  bottom: '0',
  position: 'fixed',
  right: right ? '0' : '60px',

  [mediaBreakpointUpSM]: {
    padding: right ? '0' : '50px',
  },

  [mediaBreakpointUpMD]: {
    right: '0',
    top: topSpace ? '100px' : '60px',
  },

  [mediaBreakpointUpXL]: {
    padding: '65px',
    margin: '0',
  },
}));

MenuWrapper.defaultProps = {
  flexDirection: 'initial',
};

export default MenuWrapper;
